import { useEffect, useState, useReducer } from "react"
import { topEmployees } from "../../services/ideas.service"
import svg from '../../assets/images/male.svg'
import { topEmployeesIdeasAction } from "../../store/topEmployeeIdeas"
import { useDispatch, useSelector } from "react-redux"
// import millify from 'millify'

export const TopEmployeesLeaderboard = () => {
    const [topEmpData, setTopEmpData] = useState([])
    const dispatch = useDispatch()
    useEffect(() => {
        const setTopEmp = async () => {
            let { status, data } = await topEmployees()
            if (status = 200) {
                setTopEmpData(data)
                dispatch(topEmployeesIdeasAction.setEmployeeId(data[0].EMP_ID))
            }
        }
        setTopEmp()
    }, [])
    return (
        <div className="card card-employee-task">
            <div className="card-header">
                <h4 className="card-title font-weight-600">
                    LEADERBOARD: TOP #10
                </h4>
            </div>
            <div className="card-body leaderboard">

                {topEmpData.map((emp, index) => {
                    return (
                        <div key={index} className="employee-task d-flex justify-content-between align-items-center">
                            <div className="media">
                                <div className="starshot-ring mr-1" onClick={() => {
                                    dispatch(topEmployeesIdeasAction.setEmployeeId(emp.EMP_ID))
                                }}>
                                    <div className="avatar">
                                        <div className="text-icon font-lato font-16 w-30p h-30p">A</div>
                                    </div>
                                </div>

                                <div className="media-body my-auto">
                                    <h6 className="mb-0 font-lato font-weight-600">{emp.EMP_NAME}</h6>
                                    <p className="mb-0 font-lato font-11 opacity-50">{emp.ACTION} Upvotes</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center text-p-green font-weight-600 font-20">
                                <i>#{index + 1}</i>
                            </div>
                        </div>
                    )
                })}

            </div>
        </div>
    )
}